import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-community-details-form',
  templateUrl: './community-details-form.component.html',
  styleUrls: ['./community-details-form.component.scss']
})
export class CommunityDetailsFormComponent {
  @Input() form;
  @Input() isExpandedCommunityDetails;
  gatedAnswers = [
    { label: 'residential.community_details.gated_no', value: false },
    { label: 'residential.community_details.gated_yes', value: true }
  ];

  constructor() {}

  get f() { return this.form.controls; }

}
